import { useMemo, useState } from "react";
import { feedCategories, feedItems, type FeedCategory } from "@/mocks/gossip";

export default function LatestFeed() {
  const [category, setCategory] = useState<FeedCategory>("全部");

  const list = useMemo(
    () => (category === "全部" ? feedItems : feedItems.filter((item) => item.category === category)),
    [category]
  );

  return (
    <section id="latest" className="w-full scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-secondary-700">
            <i className="ri-time-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            最新吃瓜
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新吃瓜动态 · 按分类围观</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            社区刚刚在讨论的话题都在这里。点选分类标签即可在本地筛选当前页面已有的讨论帖，无需跳转。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2" role="group" aria-label="动态分类筛选">
          {feedCategories.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setCategory(item)}
              aria-pressed={category === item}
              className={
                "rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap border " +
                (category === item
                  ? "border-primary-500 bg-primary-500 text-background-50 dark:text-foreground-950"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700")
              }
            >
              {item}
            </button>
          ))}
          <span className="ml-auto text-xs text-foreground-500">共 {list.length} 条讨论</span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 md:gap-4">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 md:flex-row md:items-start md:gap-5 md:p-5 transition-colors hover:border-primary-300"
            >
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded bg-accent-100 px-2 py-0.5 text-accent-900">{item.category}</span>
                  {item.hot && (
                    <span className="flex items-center gap-1 rounded bg-primary-100 px-2 py-0.5 text-primary-800">
                      <i className="ri-fire-fill w-3 h-3 flex items-center justify-center" aria-hidden="true"></i>
                      热议
                    </span>
                  )}
                  <span>{item.time}</span>
                </div>
                <h3 className="mt-2 text-base font-medium leading-snug text-foreground-950 md:text-lg">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-3-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                    {item.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                    {item.replies} 条回复
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                    {item.heat} 浏览
                  </span>
                </div>
              </div>
              <a
                href="#forum"
                className="inline-flex shrink-0 items-center justify-center gap-1.5 rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 cursor-pointer whitespace-nowrap self-start"
              >
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                去论坛围观
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}